import script from "./ProfileDiv.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileDiv.vue?vue&type=script&setup=true&lang=js"

import "./ProfileDiv.vue?vue&type=style&index=0&id=4ebd5679&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ebd5679"]])

export default __exports__